import Logo from "..\\src\\DJKLOGO.png";

export default function Header() {
    return (
        <>
            <h1 style={{color: "var(--accent)", paddingRight: "8px", fontSize: "xxx-large", letterSpacing: "0.5px"}}>DJK Durlach 1924 e.V.</h1>
            <img src={Logo} style={{height: "50px"}} alt='Logo'/>
        </>
    );
}